import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const StopIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="StopIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/stop">
            <path
                d="M6 2.75H18C19.7949 2.75 21.25 4.20507 21.25 6V18C21.25 19.7949 19.7949 21.25 18 21.25H6C4.20507 21.25 2.75 19.7949 2.75 18V6C2.75 4.20507 4.20507 2.75 6 2.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
            />
        </g>
    </SvgIcon>
)
